"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

import { cn } from "@/core/utils/utils"

const navItems = [
    { name: "Work", href: "/work" },
    { name: "Writing", href: "/writing" },
    { name: "Contact", href: "/contact" },
]

/**
 * Premium pill-style navigation with zero-JS CSS hover states.
 */
export function NavPill() {
    const pathname = usePathname()
    return (
        <nav className="hidden md:flex items-center group/nav">
            <div className="relative flex items-center gap-1 p-1 rounded-full border border-white/5 bg-white/5 backdrop-blur-md shadow-inner transition-colors hover:bg-white/10 hover:border-white/10">
                {navItems.map((item) => {
                    const isActive = pathname === item.href || pathname.startsWith(item.href)
                    return (
                        <Link
                            key={item.href}
                            href={item.href}
                            className={cn(
                                "relative px-5 py-2 text-sm font-medium transition-all duration-300 rounded-full",
                                "text-muted-foreground/80 hover:text-white hover:bg-white/10",
                                // Dim others when nav is hovered
                                "group-hover/nav:text-muted-foreground/40 hover:!text-white",
                                isActive ? "text-white bg-white/10" : ""
                            )}
                        >
                            {/* Active indicator dot */}
                            {isActive && (
                                <span className="absolute bottom-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,1)]" />
                            )}
                            <span className="relative z-10 transition-transform hover:scale-105 inline-block">
                                {item.name}
                            </span>
                        </Link>
                    )
                })}
            </div>
        </nav>
    )
}
